
        import i18n from 'i18n';
        import flattenObject from 'util/flattenObject';
    
            import ns7c723c2e666cf741daea33aeffa665c4en from './en.yaml'
            i18n.addResourceBundle('en', '7c723c2e666cf741daea33aeffa665c4', flattenObject(ns7c723c2e666cf741daea33aeffa665c4en), true, true);
        
        export default '7c723c2e666cf741daea33aeffa665c4';
    